
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registrate",
      function () {
        return require("private-next-pages/registrate/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/registrate"])
      });
    }
  